/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menunotfounderror3Inputs */

const en_menunotfounderror3 = /** @type {(inputs: Menunotfounderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This menu no longer exists.`)
};

const de_menunotfounderror3 = /** @type {(inputs: Menunotfounderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Menü gibt es nicht mehr.`)
};

/**
* | output |
* | --- |
* | "This menu no longer exists." |
*
* @param {Menunotfounderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menunotfounderror3 = /** @type {((inputs?: Menunotfounderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menunotfounderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menunotfounderror3(inputs)
	return de_menunotfounderror3(inputs)
});
export { menunotfounderror3 as "menuNotFoundError" }